import * as React from 'react';

import colors from '../../colors/colors';
import SVGWrapper from '../display/SVGWrapper';

const ChevronUp = ({ aspect = '2rem', color = colors.yellowDesaturated }) => (
  <SVGWrapper viewBox='0 0 24 24' aspect={aspect} stroke={color}>
    <polyline points='18 15 12 9 6 15'></polyline>
  </SVGWrapper>
);

export default ChevronUp;
